import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    iconBtnSmall: {
        height: '16px !important',
        width: '16px !important',
        backgroundColor: '#009688 !important',
        color: '#fff !important',
        padding: '10px 16px !important',
        borderRadius: '5px !important',
        fontSize: '12px !important',
        margin: '0 4px !important',
        marginTop: '4px !important',
        '&:hover': {
            backgroundColor: '#00796b !important', // Darker shade on hover
        },
        '& .MuiSvgIcon-root': {
            fontSize: '12px !important', // Adjust icon size
        }
    },
       
}));

export default useStyles;
